import React from 'react';
import EventCard from '../EventCard/EventCard';
import CauseCard from '../CauseCard/CauseCard';

type OneSearchPickerResultProps = {
  name: string;
  logo: string;
  type: string;
  eventdate?: number;
};

const OneSearchPickerResult = ({
  name,
  logo,
  type,
  eventdate,
}: OneSearchPickerResultProps) => {
  switch (type) {
    case 'Event': {
      return <EventCard name={name} date={eventdate} />;
    }
    case 'Charity':
    case 'Campaign': {
      return <CauseCard name={name} logo={logo} />;
    }
    default: {
      return null;
    }
  }
};

export default OneSearchPickerResult;
